import { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterControls from "./FilterControls";
import FilterItems from "./FilterItems";
import { dispatch_categorySearch_Event } from '../../events/SearchEvents';

function countMatches(product, filterState) {
    let matches = 0;
    const variantDetails = product.variantDetailsJson;

    if (variantDetails) {
        for (const [key, values] of Object.entries(filterState)) {
            if (
                variantDetails[key.toLowerCase()] &&
                values.includes(variantDetails[key].toLowerCase())
            ) {
                matches++;
            }
        }
    }


    return matches;
}
const Collection = (p) => {

    const { term } = useParams();

    useEffect(() => {
        dispatch_categorySearch_Event(term);
    }, [term]);

    return (
        <section className="container">
            <div className='filter-container'>
                <div className="flex-row">
                    <div className="col-5 flex-column">
                        <FilterControls />
                    </div>
                    <div className="col-19 flex-column">
                        <FilterItems />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Collection;